/** Aviso global: hay cuentas nuevas esperando al contador.
 *
 * Una cuenta que el mapping no cubre ya no detiene la publicación: se aísla en
 * «Pendiente de clasificar» y los estados cuadran. Lo que queda bloqueado son
 * las descargas oficiales del paquete de cierre de los períodos que mueve, y eso
 * tiene que verse ANTES de pulsar «Descargar», no como un error al hacerlo.
 *
 * El color nunca va solo: distintivo con icono, texto y enlace.
 */
import { Link } from "react-router-dom";
import type { ClassificationSummary } from "../api/types";
import { StatusBadge } from "./StatusBadge";

export function AvisoClasificacion({
  resumen,
}: {
  resumen: ClassificationSummary | null | undefined;
}) {
  if (!resumen || (resumen.isolated.length === 0 && resumen.review === 0)) return null;

  const aisladas = resumen.isolated;
  return (
    <div className="card banner" role="status">
      <StatusBadge tone={aisladas.length > 0 ? "serious" : "warning"}>
        {aisladas.length > 0 ? "Pendiente" : "Revisar"}
      </StatusBadge>
      <div className="banner-body">
        <strong>
          {aisladas.length > 0
            ? `${aisladas.length} cuenta${aisladas.length === 1 ? "" : "s"} pendiente${aisladas.length === 1 ? "" : "s"} de clasificar: ${aisladas.slice(0, 5).join(", ")}${aisladas.length > 5 ? "…" : ""}`
            : `${resumen.review} cuenta${resumen.review === 1 ? "" : "s"} nueva${resumen.review === 1 ? "" : "s"} para revisar`}
        </strong>
        <p className="small">
          {aisladas.length > 0
            ? "Los estados cuadran y las cifras se ven en «Pendiente de clasificar». Las descargas oficiales del paquete de cierre de los períodos que mueven están bloqueadas hasta que el contador las clasifique."
            : "Entraron en un renglón existente por su código, sin que nadie lo decidiera. No bloquean nada."}
        </p>
        <p className="small">
          <Link to="/audit/classification">Ver en Auditoría del mapping › Clasificación de cuentas</Link>
        </p>
      </div>
    </div>
  );
}
